export default (app) => {
  const ready = new Promise((resolve) => app.on("start", -10000, resolve));

  app.on("extensionMessage", async ({ message, sender }) => {
    if (message?.type === "focusPlayer") {
      await ready;
      if (!sender.tab) return { ok: false, error: "Not a Mediaqueue player tab" };
      const tab = await chrome.tabs.get(sender.tab.id);
      const player = new URL(tab.url || "https://invalid.local");
      const source = new URL(sender.url || "https://invalid.local");
      if (
        !tab.active ||
        !["http:", "https:"].includes(player.protocol) ||
        player.host !== app.settings.domain ||
        player.pathname !== "/video/player" ||
        !["http:", "https:"].includes(source.protocol) ||
        (sender.frameId === 0
          ? source.origin !== player.origin || source.pathname !== "/video/player"
          : !(
              source.hostname === "youtube.com" ||
              source.hostname.endsWith(".youtube.com") ||
              source.hostname === "youtube-nocookie.com" ||
              source.hostname.endsWith(".youtube-nocookie.com")
            ) || !source.pathname.startsWith("/embed/"))
      )
        return { ok: false, error: "Not a Mediaqueue player page" };
      const lastFocused = await chrome.windows.getLastFocused();
      let focused = false;
      const attempts = [];
      for (let attempt = 0; attempt < 3 && !focused; attempt += 1) {
        await chrome.windows.update(tab.windowId, { focused: true });
        await new Promise((resolve) => setTimeout(resolve, 100));
        const playerWindow = await chrome.windows.get(tab.windowId);
        ({ focused } = playerWindow);
        attempts.push({ focused, state: playerWindow.state });
      }
      app.event("extensionMessage", {
        message: {
          type: "log",
          message: "focusPlayer",
          data: { windowId: tab.windowId, lastFocusedWindowId: lastFocused.id, attempts },
        },
        sender,
      });
      return {
        ok: focused,
        focused,
        windowId: tab.windowId,
        error: focused ? undefined : "Chrome window remains unfocused",
      };
    }
    if (message?.type === "log") message.data = { ...message.data, frameId: sender.frameId, url: sender.url };
    else if (message?.type !== "ids") return { ok: false, error: "Unsupported extension message" };
    else {
      const source = new URL(sender.url || "https://invalid.local");
      if (
        !["youtube.com", "www.youtube.com", "m.youtube.com"].includes(source.hostname) ||
        source.pathname !== "/feed/subscriptions"
      )
        return { ok: false, error: "Not a YouTube subscriptions page" };
    }

    await ready;
    const session = app.session.user;
    if (!session?.sessionid) return { ok: false, error: "Sign in through the Mediaqueue extension popup first" };

    let timer;
    let finished = false;
    try {
      return await Promise.race([
        app.connection
          .event("connection", { wait: true })
          .then(() =>
            finished
              ? undefined
              : app.connection.emit({ type: "extensionMessage", message, sessionid: session.sessionid }),
          ),
        new Promise((resolve) => {
          timer = setTimeout(() => resolve({ ok: false, error: "Mediaqueue import timed out" }), 20000);
        }),
      ]);
    } finally {
      finished = true;
      clearTimeout(timer);
    }
  });
};
